import { 
    setupFormCommonBehaviour,
} from ".";

import { 
    InputNameConfigMap,
    FileUploadItemError,
    uploadAttachments,
} from "./file-upload";

declare const jQuery: any;
const $ = jQuery;

const ajaxAction: string = "iw_account_update_details";

const ajaxCall: Function = window["iw"].utils.ajaxCall;
const errorModal: Function = window["iw"].modal.errorModal;
const successModal: Function = window["iw"].modal.successModal;
const waitModal: Function = window["iw"].modal.waitModal;
const scrollToWithHeaderOffset: Function = window["iw"].layout.scrollToWithHeaderOffset;

export function initEditMyAccount($main): void
{
    const $mainInner = $main.children(`[data-edit-my-account]`);
    if ($mainInner.length === 0)
    {
        return;
    }
    initMainInner($mainInner);
}

function initMainInner($mainInner): void
{
    const $save = $mainInner.find("[data-main-buttons] [data-save]");

    let unsavedChanges = false;

    const onFirstChange = () => {
        $save.removeAttr("disabled");
        unsavedChanges = true;
    };

    const commonCtrls = setupFormCommonBehaviour($mainInner, onFirstChange);

    const buildBasicAjaxData = (rawData) => {
        return {
            email: rawData.email,
            new_password: rawData.new_password,
            old_password: rawData.old_password
        };
    };

    const saveBasicAjaxData = async (basicAjaxData): Promise<void> => {
        waitModal(`Submitting account data, please wait...`);
        return await ajaxCall(ajaxAction, basicAjaxData);
    };

    const getUpdatedMainInnerHtml = async (): Promise<{ html: string, previewUrl: string }> => {
        waitModal(`Updating account page, please wait...`);
        const response = await ajaxCall("supp-acc-get-form", { form: "edit_my_account" });
        if (!response?.html) {
            console.error(`getUpdatedMainInnerHtml - bad response:`, response);
            throw new Error(`No response.html`);
        }
        return response;
    };

    const save = async () => {
        const rawData = commonCtrls.gatherData();
        if (!rawData)
        {
            // User data invalid. Error modal has already been displayed at this point.
            return;
        }
        const basicAjaxData = buildBasicAjaxData(rawData);
        if (!basicAjaxData)
        {
            throw new Error(`No basicAjaxData`);
        }
        $mainInner.addClass("busy");
        try
        {
            await saveBasicAjaxData(basicAjaxData);
            const response = await getUpdatedMainInnerHtml();
            commonCtrls.cancelWarnBeforePageLeave();
            $mainInner.html($(response.html).html());
        }
        catch (error)
        {
            if (!(error instanceof FileUploadItemError)) // FileUploadItemError already shows modal before throw
            {
                const errorMsg: string = error?.response?.userMsg || `Failed to save. If the problem persists, please get in touch.`;
                errorModal(errorMsg);
            }
            console.error("Save failed:", error);
            return;
        }
        finally
        {
            $mainInner.removeClass("busy");
        }
        initMainInner($mainInner);
        scrollToWithHeaderOffset($mainInner);
        successModal(
            `Your account has been updated.`,
            undefined,
            5000
        );
    };

    $save.on("click", function (event) {
        save();
        return false;
    });
}
